import type { ApiUsageTranslations } from '../interfaces/apiUsage';

export const apiUsageTranslations: ApiUsageTranslations = {
  page_title: 'Uso de API',
  page_description:
    'Llamadas realizadas con API keys, desglosadas por recurso y periodo.',

  window_7d: '7 días',
  window_30d: '30 días',
  window_90d: '90 días',

  granularity_label: 'Agrupar por',
  granularity_hour: 'Hora',
  granularity_day: 'Día',
  granularity_week: 'Semana',
  granularity_month: 'Mes',

  filter_all_resources: 'Todos los recursos',
  filter_all_keys: 'Todas las API keys',
  filter_resource_aria: 'Filtrar por recurso',
  filter_key_aria: 'Filtrar por API key',

  kpi_total_calls: 'Llamadas totales',
  kpi_total_calls_sub: 'ventana actual',
  kpi_errors: 'Errores',
  kpi_error_rate: 'Tasa de error',
  kpi_error_rate_sub: 'respuestas ≥ 400',
  kpi_avg_latency: 'Latencia media',
  kpi_p95_latency: 'Latencia p95',
  kpi_latency_sub: 'tiempo de respuesta',

  chart_title: 'Llamadas en el tiempo',
  chart_sub: 'Total de llamadas por periodo',
  chart_legend_calls: 'Llamadas',
  chart_legend_errors: 'Errores',
  chart_empty: 'Sin llamadas en la ventana seleccionada.',

  table_title: 'Detalle por recurso y API key',
  table_sub: 'Ordenado por número de llamadas',
  col_resource: 'Recurso',
  col_api_key: 'API key',
  col_calls: 'Llamadas',
  col_errors: 'Errores',
  col_error_rate: 'Tasa error',
  col_avg_latency: 'Media (ms)',
  col_p95_latency: 'p95 (ms)',

  unknown_key: 'Desconocida',

  empty_title: 'Sin datos de uso',
  empty_description:
    'Aún no se han registrado llamadas con API key en este periodo.',
  error_title: 'No se pudo cargar el uso de la API',
  retry: 'Reintentar',
};
